module.exports = __webpack_public_path__ + "img/1549743188.388e7cd3.jpg";